import React from 'react';
import { ArrowLeft, MapPin, Phone, Clock, Car, Bus, Plane } from 'lucide-react';
import { Button } from '../../components/ui/button';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import WhatsAppButton from '../../components/WhatsAppButton';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../../i18n/pageTranslations';

const Marbella = () => {
  const navigate = useNavigate();
  const lang = useLanguage();

  const texts = {
    es: {
      backTo: 'Volver a Contacto',
      title: 'Clínica Estética Alameda',
      subtitle: 'Marbella - Rinomodelación con el Dr. Ángel Ruiz Norro',
      locationTitle: 'Ubicación',
      clinicName: 'Clínica Estética Alameda de Marbella',
      phone: 'Teléfono',
      schedule: 'Horario',
      scheduleText: 'Lunes a Viernes: 10:00 - 14:00 y 16:00 - 20:00',
      saturdayText: 'Sábados: Con cita previa',
      howToGetTitle: 'Cómo Llegar',
      byCar: 'En Coche',
      byCarDesc: 'La clínica está situada en el centro de Marbella, en la Calle Carlos Mackintosh. Fácil acceso desde la autovía A-7. Parking público disponible en las inmediaciones.',
      byBus: 'En Autobús',
      byBusDesc: 'Paradas de autobús urbano a pocos minutos andando. Conexión directa con la estación de autobuses de Marbella.',
      fromAirport: 'Desde el Aeropuerto',
      fromAirportDesc: 'A 45 minutos del Aeropuerto de Málaga-Costa del Sol (AGP). Disponemos de servicio de recogida para pacientes que lo soliciten.',
      viewMap: 'Ver en Google Maps',
      aboutClinic: 'Sobre la Clínica',
      aboutClinicText: 'La Clínica Estética Alameda de Marbella es el centro donde el Dr. Ángel Ruiz Norro realiza los procedimientos de rinomodelación. Cuenta con instalaciones modernas, totalmente equipadas y con todas las autorizaciones sanitarias necesarias para garantizar la máxima seguridad y confort de los pacientes.',
      ctaTitle: 'Solicita tu Consulta en Marbella',
      ctaDesc: 'Solicite una consulta de valoración personalizada',
    },
    en: {
      backTo: 'Back to Contact',
      title: 'Alameda Aesthetic Clinic',
      subtitle: 'Marbella - Rhinomodeling with Dr. Ángel Ruiz Norro',
      locationTitle: 'Location',
      clinicName: 'Alameda Aesthetic Clinic of Marbella',
      phone: 'Phone',
      schedule: 'Schedule',
      scheduleText: 'Monday to Friday: 10:00 - 14:00 and 16:00 - 20:00',
      saturdayText: 'Saturdays: By appointment',
      howToGetTitle: 'How to Get Here',
      byCar: 'By Car',
      byCarDesc: 'The clinic is located in the center of Marbella, on Carlos Mackintosh Street. Easy access from the A-7 highway. Public parking available nearby.',
      byBus: 'By Bus',
      byBusDesc: 'Urban bus stops within walking distance. Direct connection to Marbella bus station.',
      fromAirport: 'From the Airport',
      fromAirportDesc: '45 minutes from Málaga-Costa del Sol Airport (AGP). Pickup service available for patients who request it.',
      viewMap: 'View on Google Maps',
      aboutClinic: 'About the Clinic',
      aboutClinicText: 'The Alameda Aesthetic Clinic of Marbella is the center where Dr. Ángel Ruiz Norro performs rhinomodeling procedures. It has modern facilities, fully equipped and with all the necessary health authorizations to guarantee maximum safety and comfort for patients.',
      ctaTitle: 'Request Your Consultation in Marbella',
      ctaDesc: 'Request a personalized assessment consultation',
    },
    fr: {
      backTo: 'Retour au Contact',
      title: 'Clinique Esthétique Alameda',
      subtitle: 'Marbella - Rhinomodelage avec le Dr. Ángel Ruiz Norro',
      locationTitle: 'Emplacement',
      clinicName: 'Clinique Esthétique Alameda de Marbella',
      phone: 'Téléphone',
      schedule: 'Horaires',
      scheduleText: 'Lundi à Vendredi: 10h00 - 14h00 et 16h00 - 20h00',
      saturdayText: 'Samedis: Sur rendez-vous',
      howToGetTitle: 'Comment Venir',
      byCar: 'En Voiture',
      byCarDesc: 'La clinique est située au centre de Marbella, rue Carlos Mackintosh. Accès facile depuis l\'autoroute A-7. Parking public disponible à proximité.',
      byBus: 'En Bus',
      byBusDesc: 'Arrêts de bus urbain à quelques minutes à pied. Connexion directe avec la gare routière de Marbella.',
      fromAirport: 'Depuis l\'Aéroport',
      fromAirportDesc: 'À 45 minutes de l\'aéroport de Málaga-Costa del Sol (AGP). Service de transport disponible pour les patients qui le demandent.',
      viewMap: 'Voir sur Google Maps',
      aboutClinic: 'À Propos de la Clinique',
      aboutClinicText: 'La Clinique Esthétique Alameda de Marbella est le centre où le Dr. Ángel Ruiz Norro réalise les procédures de rhinomodelage. Elle dispose d\'installations modernes, entièrement équipées et de toutes les autorisations sanitaires nécessaires pour garantir une sécurité et un confort maximum aux patients.',
      ctaTitle: 'Demandez Votre Consultation à Marbella',
      ctaDesc: 'Demandez une consultation d\'évaluation personnalisée',
    },
    pt: {
      backTo: 'Voltar para Contato',
      title: 'Clínica Estética Alameda',
      subtitle: 'Marbella - Rinomodelação com o Dr. Ángel Ruiz Norro',
      locationTitle: 'Localização',
      clinicName: 'Clínica Estética Alameda de Marbella',
      phone: 'Telefone',
      schedule: 'Horário',
      scheduleText: 'Segunda a Sexta: 10:00 - 14:00 e 16:00 - 20:00',
      saturdayText: 'Sábados: Com hora marcada',
      howToGetTitle: 'Como Chegar',
      byCar: 'De Carro',
      byCarDesc: 'A clínica está localizada no centro de Marbella, na Rua Carlos Mackintosh. Acesso fácil pela autoestrada A-7. Estacionamento público disponível nas proximidades.',
      byBus: 'De Ônibus',
      byBusDesc: 'Pontos de ônibus urbano a poucos minutos a pé. Conexão direta com a estação de ônibus de Marbella.',
      fromAirport: 'Do Aeroporto',
      fromAirportDesc: 'A 45 minutos do Aeroporto de Málaga-Costa del Sol (AGP). Serviço de transporte disponível para pacientes que solicitarem.',
      viewMap: 'Ver no Google Maps',
      aboutClinic: 'Sobre a Clínica',
      aboutClinicText: 'A Clínica Estética Alameda de Marbella é o centro onde o Dr. Ángel Ruiz Norro realiza os procedimentos de rinomodelação. Conta com instalações modernas, totalmente equipadas e com todas as autorizações sanitárias necessárias para garantir a máxima segurança e conforto aos pacientes.',
      ctaTitle: 'Solicite sua Consulta em Marbella',
      ctaDesc: 'Solicite uma consulta de avaliação personalizada',
    },
  };

  const t = texts[lang] || texts.es;

  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Breadcrumb */}
      <div className="pt-24 pb-4 bg-cream">
        <div className="container mx-auto px-4">
          <button 
            onClick={() => navigate('/rinomodelacion/contacto')}
            className="flex items-center gap-2 text-gold hover:text-gold transition-colors"
          >
            <ArrowLeft size={20} />
            <span>{t.backTo}</span>
          </button>
        </div>
      </div>

      {/* Hero */}
      <section className="relative py-24 px-4">
        <div className="absolute inset-0">
          <img 
            src="https://images.pexels.com/photos/3825527/pexels-photo-3825527.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
            alt="Marbella"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-[#1C1C1A]/80"></div>
        </div>
        <div className="container mx-auto max-w-5xl text-center relative z-10">
          <h1 className="text-4xl md:text-5xl font-light text-white mb-6">
            {t.title}
          </h1>
          <p className="text-xl text-white/80">
            {t.subtitle}
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 px-4">
        <div className="container mx-auto max-w-5xl">
          
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12">
            {/* Info */}
            <div className="bg-ivory p-8 rounded-none shadow-lg">
              <div className="flex items-center gap-4 mb-6">
                <div className="w-14 h-14 bg-gold/10 rounded-none flex items-center justify-center">
                  <MapPin className="text-gold" size={28} />
                </div>
                <h2 className="text-2xl font-light text-[#1C1C1A]">{t.locationTitle}</h2>
              </div>
              
              <div className="space-y-4 mb-6">
                <p className="text-text-secondary">
                  <strong>{t.clinicName}</strong><br />
                  C/ Carlos Mackintosh, 3<br />
                  29602 Marbella, Málaga
                </p>
              </div>

              <div className="flex items-center gap-3 mb-4">
                <Phone className="text-gold" size={20} />
                <div>
                  <p className="text-text-secondary">
                    <strong>{t.phone}:</strong> 952 76 45 47
                  </p>
                  <p className="text-text-secondary">
                    <strong>WhatsApp:</strong> 696 345 792
                  </p>
                </div>
              </div>

              <div className="flex items-center gap-3">
                <Clock className="text-gold" size={20} />
                <div>
                  <p className="text-text-secondary">
                    <strong>{t.schedule}:</strong><br />
                    {t.scheduleText}<br />
                    {t.saturdayText}
                  </p>
                </div>
              </div>
            </div>

            {/* How to get there */}
            <div className="bg-ivory p-8 rounded-none shadow-lg">
              <h2 className="text-2xl font-light text-[#1C1C1A] mb-6">{t.howToGetTitle}</h2>
              
              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 bg-gold/10 rounded-none flex items-center justify-center flex-shrink-0">
                    <Car className="text-gold" size={20} />
                  </div>
                  <div>
                    <h4 className="font-semibold text-[#1C1C1A] mb-1">{t.byCar}</h4>
                    <p className="text-text-secondary text-sm">
                      {t.byCarDesc}
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 bg-gold/10 rounded-none flex items-center justify-center flex-shrink-0">
                    <Bus className="text-gold" size={20} />
                  </div>
                  <div>
                    <h4 className="font-semibold text-[#1C1C1A] mb-1">{t.byBus}</h4>
                    <p className="text-text-secondary text-sm">
                      {t.byBusDesc}
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 bg-purple-100 rounded-none flex items-center justify-center flex-shrink-0">
                    <Plane className="text-purple-600" size={20} />
                  </div>
                  <div>
                    <h4 className="font-semibold text-[#1C1C1A] mb-1">{t.fromAirport}</h4>
                    <p className="text-text-secondary text-sm">
                      {t.fromAirportDesc}
                    </p>
                  </div>
                </div>
              </div>

              <Button 
                onClick={() => window.open('https://maps.google.com/?q=Calle+Carlos+Mackintosh+3+Marbella+29602', '_blank')}
                className="w-full bg-gold hover:bg-gold text-white mt-6"
              >
                <MapPin className="mr-2" size={18} />
                {t.viewMap}
              </Button>
            </div>
          </div>

          {/* About the clinic */}
          <div className="bg-cream p-8 rounded-none mb-12">
            <h3 className="text-2xl font-light text-[#1C1C1A] mb-6 text-center">
              {t.aboutClinic}
            </h3>
            <p className="text-text-secondary leading-relaxed text-center max-w-3xl mx-auto">
              {t.aboutClinicText}
            </p>
          </div>

          {/* CTA */}
          <div className="bg-gradient-to-r from-[#1C1C1A] to-[#1C1C1A] p-8 rounded-none text-white text-center">
            <h3 className="text-2xl font-light mb-4">{t.ctaTitle}</h3>
            <p className="text-white/80 mb-6">
              {t.ctaDesc}
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button 
                onClick={() => window.open('tel:952764547', '_self')}
                className="bg-gold hover:bg-gold text-white px-6 py-3"
              >
                <Phone className="mr-2" size={18} />
                952 76 45 47
              </Button>
              <Button 
                onClick={() => window.open('https://wa.me/34696345792', '_blank')}
                className="bg-gold500 hover:bg-gold600 text-white px-6 py-3"
              >
                WhatsApp
              </Button>
            </div>
          </div>
        </div>
      </section>

      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default Marbella;
